"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSplitterFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var PaymentSplitterFactory = /** @class */ (function (_super) {
    __extends(PaymentSplitterFactory, _super);
    function PaymentSplitterFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PaymentSplitterFactory.prototype.deploy = function (payees, shares_, overrides) {
        return _super.prototype.deploy.call(this, payees, shares_, overrides || {});
    };
    PaymentSplitterFactory.prototype.getDeployTransaction = function (payees, shares_, overrides) {
        return _super.prototype.getDeployTransaction.call(this, payees, shares_, overrides || {});
    };
    PaymentSplitterFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PaymentSplitterFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PaymentSplitterFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return PaymentSplitterFactory;
}(contracts_1.ContractFactory));
exports.PaymentSplitterFactory = PaymentSplitterFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: 'address[]',
                name: 'payees',
                type: 'address[]',
            },
            {
                internalType: 'uint256[]',
                name: 'shares_',
                type: 'uint256[]',
            },
        ],
        stateMutability: 'payable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
            },
        ],
        name: 'PayeeAdded',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'PaymentReceived',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'amount',
                type: 'uint256',
            },
        ],
        name: 'PaymentReleased',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'index',
                type: 'uint256',
            },
        ],
        name: 'payee',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address payable',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'release',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'released',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
        ],
        name: 'shares',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalReleased',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalShares',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        stateMutability: 'payable',
        type: 'receive',
    },
];
var _bytecode = '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';
//# sourceMappingURL=PaymentSplitterFactory.js.map